//PolyFills
import "./include-string-startswith-endswith-polyfill.js";

//IE unterstützt die forEach-Methode nicht für NodeList (wie sie von querySelectorAll() ausgegeben wird), wohl aber für Arrays (ab IE 9).
if (window.NodeList && !NodeList.prototype.forEach) {
   NodeList.prototype.forEach = Array.prototype.forEach;
}

//MAIN

const TIMEOUT = 24 * 60 * 60000; //24 Stunden in Millisekunden
const KEY_PREFIX = "fib_";
const CSS_CLASS_UNSUBMITTED_CHANGES = "unsubmittedChanges";

const ls = window.localStorage;

let hsButtonsDisabled = false;

function normalizeMatch(match) { 
    //match ist entweder 0 (kein Suchtreffer) oder ein Array mit den Capturing Groups (an Index 0 der komplette Match, an Index 1 die CG 1 etc.)
    //Hier wird erwartet, dass match entweder 0 ist oder den zu normalisierenden URL-Ausschnitt an Index 1 (erste Capt. Group) enthält!
    //Dieser Ausschnitt an Index 1 wiederum muss die Form "/Veranstaltername/Servicename/*" haben (und darf nicht auf "/", "?" oder ";" o.ä. enden), 
    //und diese Methode ersetzt darin 1. "Servicename" durch "Aufgabentext" und hängt 2. am String-Ende einen Slash an.
    if (match === null) 
        return null;
    else {
        let path = match[1]; //Inhalt der ersten Capturing Group des Matches
        path = path.replace(/^(\/[^\/]+\/)[^\/]+/g, "$1Aufgabentext") + "/";
        return path;
    }
}

const module = {

    KEY_PREFIX: KEY_PREFIX,

    /**
     * Nimmt einen URL oder URL-Path entgegen (also String beginnend entweder mit http://servername/ oder https://servername/ oder direkt mit "/") 
     * und erwartet einen URL zu einem Service mit mindestens Verstantaltername, Servicename, KursNr, VersionsNr (allgemeiner: 4 alphanumerische Path-Einträge) 
     * sowie Heftnummer und Aufgabennummer (2 numerische Path-Einträge, von denen der zweite auch mit "r" beginnen darf)
     * und macht daraus einen intern als Aufgabenschlüssel zu verwendenden String.
     * Dies geschieht, indem der vorhandene Servicename durch "Aufgabentext" ersetzt wird, ein Servername samt Protokollpräfix vorne ebenso entfernt
     * wird wie z.B. Query-Strings, ";jsessionid=..." oder andere Pfadsuffixe hinter der Aufgabennummer (incl. HTML-Dateiname) etc.,
     * und dass der String hinter der Aufgabennummer immer mit "/" abschließt.
     * Macht also z.B. aus "https://online-uebungssystem.feu.de/vus/Einsendung/12345/WS12/2/12/xyz" den String "vus/Aufgabentext/12345/WS12/2/12"
     * oder aus "/test/Service/12345/SS24/2/r1;jsessionid=...?querystring" den String "
     * 
     * (Den Servicenamen "Aufgabentext" könnte man eigentlich auch weglassen, der bleibt nun aber aus Abwärtskompatibilitätsgründen erstmal drin,
     * damit nicht während eines Updates plötzlich ggf. zwischengespeicherte Eingaben für die Studierenden während ihrer Arbeit verloren gehen.
     * Dasselbe gilt für den abschließenden Slash, der nicht nötig wäre, nun aber immer angefügt wird, selbst wenn der Original-URL dort keinen Slash
     * hinter der Aufgabennummer enthalten sollte.)
     * Wenn der URL jedoch keinen Service-URL mit Aufgabenkontext beschreibt, also nicht einen Pfad aus "/Text/Text/Text/Text/Ziffern/Ziffern" enthält,
     * dann wird null ausgegeben!
     * @param {string} url s.o.
     * @returns {string} normalisierter Pfad
     */
    normalizeUrlPathToAufgKey: function(url) {
        const match = url.match(/^(?:https?:\/\/[^\/]+)?((?:\/[^;?\/]+){4}\/\d+\/r*\d+)(?:[\/;?]|$)/);
        return normalizeMatch(match);
    },
    
    /**
     * Entnimmt dem URL lediglich den Kurskontext-Pfad und normalisiert ihn ebenfalls durch Austauschen des Servicenamens durch "Aufgabentext".
     * Ergebnis ist ein String der Art "/vus/Aufgabentext/12345/WS12/" oder null, falls der Original-URL nicht mindestens einen Kurskontext beschreibt.
     * @param {string} url
     * @returns {string} normalisierter Pfad
     */
    normalizeUrlPathKursKey: function(url) {
        const match = url.match(/^(?:https?:\/\/[^\/]+)?((?:\/[^;?\/]+){4})(?:[\/;?]|$)/);
        return normalizeMatch(match);
    },

    cleanOld: function() {
        const asString = ls.getItem(KEY_PREFIX + 'lastChanged');
        if (asString) {
            const asInt = parseInt(asString);
            if (asInt + TIMEOUT < Date.now()) {
                this.clean();
            }
        }
    },

    /**
     * Entfernt Field-Input-Backups für eine Aufgabe, Teilaufgabe, ein ganzes Heft oder sogar alle.
     * Wenn aufgabenKey und ta (Teilaufgaben"nummer" als Großbuchstabe) übergeben wurde, lösche alle Feldeinsendungen zu dieser Teilaufgabe.
     * Wenn aufgabenKey übergeben wurde, lösche alle gespeicherten Feldeingaben zu dieser Aufgabe. 
     * Wenn aufgabenKey undefined, lösche alle gespeicherten Feldeingaben (aufgabenübergreifend)!
     * @param {string} aufgabenKey Normalerweise ein "Aufgabenschlüssel" in Form eines URL-Pfads zum Aufgabentext-Service der Form 
     * "/veranstaltername/Aufgabentext/kursnr/versionsnr/heftnr/aufgnr/"
     * Es ist auch möglich, nur ein Präfix davon anzugeben, insbesondere einen Aufgaben_heft_-Schlüssel, indem das Suffix "aufgnr/" weggelassen wird,
     * dann wird für alle Aufgaben dieses Hefts gelöscht. Genauer werden alle FIB-Datensätze gelöscht, deren AufgabenKey mit den hier übergebenen
     * Präfix beginnt. (Das funktioniert aber nur, wenn kein zweiter Parameter ta für eine Teilaufgabe übergeben wird. In letzterem Fall hat
     * der AufgabenKey vollständig zu sein und insb. auch auf Slash hinter der Aufgabennummer zu enden (d.h. weder darf der Slash fehlen,
     * noch dürfen weitere Pfadsuffixe, Query-Strings, jSession-IDs etc. angehängt sein.
     * @param {string} ta Teilaufgabennr (Klein- oder Großbuchstabe). Darf undefined bleiben, wenn zu allen TA der Aufgabe gelöscht werden soll.
     * @returns {undefined}
     */
    clean: function(aufgabenKey, ta) {
        //Leere nicht das gesamte LocalStorage (falls andere Scripte dort auch Dinge ablegen, die länger als 24 Stunden halten sollen),
        //sondern nur alle Keys mit Prefix "fib_" (field input backup).
        let keyPrefix = KEY_PREFIX;
        if (aufgabenKey) {
            keyPrefix += aufgabenKey;
            if (ta) {
                keyPrefix += '_' + ta.toUpperCase() + '_';
            }
        }

        //Ein Live-Iterieren über die Key-Indizex und gleichzeitiges Löschen ist nicht möglich, weil sich mit dem Löschen eines Eintrags
        //live die Key-Indizes der weiteren Einträge und die Länge ls.length ändert.
        //Vielleicht würde es funktionieren, in der For-Bedingung immer i < ls.length zu schreiben, aber da ich nicht sicher sein kann,
        //dass sich nicht nur die Indizes höherer Items verändern, machen wir's lieber sauber in zwei Schritten:
        //1. Erstelle eine Liste aller Keys der zu löschenden Entries
        //2. Lösche alle Entries mit Keys aus der Liste.

        //ad 1)
        let toDelete = [];
        for (let i=0, l=ls.length; i < l; i++) {
            const key = ls.key(i);
            if (key.startsWith(keyPrefix)) {
                toDelete.push(key);
            }
        }
        //ad 2)
        toDelete.forEach(key => ls.removeItem(key));
    },

    /**
     * Kann für alle Seiten, Aufgabenseiten ebenso wie Quittungen, aufgerufen werden, (theoretisch auch für StudentenStartSeite, aber da gibt's ja keinen AufgabenKey).
     * Wenn die Seite eine Quittung ist, die im body-Tag eine Angabe der Teilaufgabe(n) enthält, deren Einsendungseingang sie quittiert, dann 
     * werden die Local Backups zu dieser/-n quittierten Teilaufgabe/-n gelöscht. Andernfalls passiert einfach nichts.
     * @param {string} aufgabenKey Der AufgabenKey
     * @returns {undefined}
     */
    cleanQuittiert: function(aufgabenKey) {
        //Suche im Body-Tag nach Quittungsmarkierung (data-quittung-zu):
        const quittungZu = document.body.dataset.quittungZu;
        if (typeof quittungZu === "string") {
            const taNrn = quittungZu.split(',');
            taNrn.forEach(ta => this.clean(aufgabenKey, ta));
        }
    },
    
    /**
     * Wenn eine Einsendung nicht zu einer Quittung führt, aber zu einem Forbidden-Code (Response-Code 403) führt und dieser vom OÜS auch nochmal
     * in einem Data-Attribut (data-rc) des body-Elements steht (was respondErrMsg() so einträgt), dann gehe davon aus, dass Einsendungen zu dieser Aufgabe
     * nicht möglich sind und es daher keinen Sinn ergibt, die Eingaben aufzuheben und den Nutzer daran zu erinnern, dass er sie noch einsenden muss.
     * Das irritiert höchstens, wenn er eh nicht einsenden kann.
     * Das ist insbesondere der Fall, wenn inzwischen der Einsendeschluss verstrichen ist.
     * @param {type} aufgabenKey Der AufgabenKey. Alle FIB-Einträge zu diesem Key werden gelöscht, wenn data-rc="403" im body-Element gefunden wird.
     * @returns {undefined}
     */
    cleanIfSubmitForbidden: function(aufgabenKey) {
        const rc = document.body.dataset.rc; //Notiz: Auch wenn der Code ein Int ist, sind DataSet-Entries (=Attributinhalte) immer Strings.
        if (rc === "403") {
            this.clean(aufgabenKey);
        }
    },

    /**
     * Durchsucht die LocalStorage nach allen Keys, die vorliegende, uneingesendete Eingaben zu Formularfeldern enthalten, und ermittelt alle Aufgaben,
     * zu denen solche Daten vorliegen
     * @returns {Set} Menge der AufgabenKeys der Aufgaben, zu denen unsumbitted Entries gefunden wurden. Jeweils als Teil-URL-Pfad, beginnend und endend mit "/",
     * im Format "/Veranstaltername/Aufgabentext/KursNr/VersionsNr/HeftNr/AufgNr/"
     */
    aufgabenMitUngespeichertenEingaben: function() {
        //durchsuche alle mit "fib_/" beginnenden Keys. Der Slash schließt insb. den fib_lastChanged-Key aus.
        const keyPrefix = KEY_PREFIX + "/";
        const out = new Set();
        for (let i=0, l=ls.length; i < l; i++) {
            const key = ls.key(i);
            if (key.startsWith(keyPrefix)) {
                //Diese Keys sollen wie folgt aufgebaut sein: fib_/six/Aufgabentext/12345/WS23/1/2_...
                //Schneide nun den Teil zwischen dem ersten und zweiten Underscore aus, um den URL-Part zu bekommen, der mit echten Link-URLs zu vergleichen ist.
                const uripart = key.split('_', 2)[1]; //Da der Key ja mit "fib_" beginnt, muss er einen Underscore enthalten und sich somit in mindestens zwei Teile splitten lassen.
                out.add(uripart);
            }
        }
        return out;
    },

    /**
     * Alle Links, die zu aufgabenMitUngespeichertenEingaben() führen, werden mit einer CSS-Klasse und einem title ausgezeichnet.
     * Dient dazu, in Aufgabenlisten (Menüs mit Links zu Aufgabenseiten) die sichtbaren Markierungen anbringen zu können, die den Studierenden mitteilen,
     * dass in dieser Aufgabe ungespeicherte Eingaben vorliegen.
     * @returns {boolean} true, wenn mindestens ein Link gefunden und markiert wurde, false, wenn die Seite danach keine FIB-Marker enthält.
     */
    addMarkerToLinks: function() {
        let addedMarker = false;
        const aufgUriparts = this.aufgabenMitUngespeichertenEingaben();
        aufgUriparts.forEach(uripart => 
            //Markiere Links nur für (noch) offene Hefte. Das sind Aufgabenlinks, die innerhalb eines Elements mit class="heftOffen" stehen.
            //(Das kann die ganze Aufgabenliste (ul oder div) sein oder auch ein List-Item zum Link, jedenfalls irgendein Vorfahr.)
            document.querySelectorAll(".heftOffen a[href*='" + uripart + "']")
                    .forEach(link => {
                        link.classList.add(CSS_CLASS_UNSUBMITTED_CHANGES);
                        link.title="Letzte Eingaben wurden noch nicht eingesendet!";
                        addedMarker = true;
                    })
        );
        return addedMarker;
    },

    /**
     * Sucht nach Heft-Schließen-Buttons zu Heften, zu denen noch ungespeicherte Eingaben vorliegen, und setzt legt für diese entsprechende Warnungs-Texte
     * im Dataset ab, die dann später mit in die Heftschließen-Confirmationbox einfließen, falls der jeweilige Button gedrückt wird.
     * @param {string} kursKey aus Document-URL per normalizeUrlPathKursKey() gewonnener URL-Teil. 
     * Auch die Übergabe eines per normalizeUrlPathToAufgKey() gewonnener AufgabenKey-URL ist erlaubt, dann wird nur der KursKey-Teil davon (Präfix)
     * ausgewertet.
     * Also String der Art
     * "/vus/Aufgabentext/01614/SS05/".
     * Dieser KursKey wird verwendet, um nicht auf die Existenz von FIB-Entries zu anderen Kursen (bei gleicher Heftnummer) zu reagieren, 
     * sondern nur auf Einträge zum selben Heft desselben Kurses.
     * @returns {undefined}
     */
    addHsConfirmations: function(kursKey) {
        const parts = kursKey.split('/'); 
        //Da der Key mit "/" beginnt, ist parts[0] == "", der Veranstaltername steht an Index 1, die Kursnummer an 3 und die VersionsNr an 4.
        document.querySelectorAll("form[action*='/HeftEinsendung/']").forEach(form =>
                form.querySelectorAll("button[type='submit'][name^='ABSENDEN']").forEach(btn => {
                        const sHeftNr = btn.name.substring('ABSENDEN'.length); 
                        //Da die Heftnummern immer ohne führende Nullen als Int notiert werden und hier beide Vergleichswerte (HeftNr im Aufg-URL
                        //und HeftNr in HS-Button-Key) jeweils als String vorliegen, kann auf parseInt verzichtet werden -- ein String-Vergleich genügt.
                        const aufgUriparts = this.aufgabenMitUngespeichertenEingaben();
                        let foundUnsaved = false;
                        //Über eine Menge kann ich nur mit forEach iterieren, und somit leider immer nur vollständig.
                        //Eine For-Schleife geht nicht, weil eine Set keine Array-Indexes kennt. Und Set.values() wird vom IE nicht unterstützt.
                        aufgUriparts.forEach(aufg => {
                            if (!foundUnsaved) {
                                const rex = new RegExp("^/" + parts[1] + "/Aufgabentext/" + parts[3] + "/" + parts[4] + "/" + sHeftNr + "/");
                                if (rex.test(aufg)) {
                                    //Es wurde eine Aufgabe mit ungespeicherten Eingaben gefunden zum Heft, dessen Heft-Schließen-Button gerade betrachtet wird.
                                    foundUnsaved = true;
                                } 
                            }
                        });
                        if (foundUnsaved) {
                            btn.dataset.hsConfirmation = "ACHTUNG: Zu mindestens einer Aufgabe des zu schließenden Aufgabenhefts haben Sie möglicherweise "
                                    + "die Seite verlassen, ohne Ihre Eingaben gespeichert / eingesendet zu haben!\n"
                                    + "Falls in der Aufgabenübersicht noch Aufgaben farblich und mit Achtung-Symbol hervorgehoben sein sollten, "
                                    + "und Sie nicht sicher sind, ob Sie dort absichtlich die letzten Eingaben nicht speichern, sondern verwerfen wollten, "
                                    + "dann brechen Sie hier am besten zunächst ab und prüfen Sie für die so markierten Aufgaben, ob alle gewünschten Eingaben gespeichert wurden!"
                                    + "\n"
                                    + "Möchten Sie das Heft nun wirklich schließen und damit alle ggf. noch ungespeicherten / nicht eingesendeten Eingaben verwerfen?";
                            btn.dataset.cleanHeftKey = module.normalizeUrlPathKursKey(form.action) + sHeftNr + '/';
                        }
                })
        );
    },

    disableAufgHsButtons: function() {
        if (!hsButtonsDisabled) {
            document.querySelectorAll("form[action*='/HeftEinsendung/']").forEach(form =>
                    form.querySelectorAll("button[type='submit'][name^='ABSENDEN']").forEach(btn => {
                        btn.disabled = true;
                        btn.title = "Sie haben Eingaben vorgenommen, die noch nicht eingesendet wurden! Senden Sie zunächst Ihre Eingaben ein oder "
                                + "laden Sie die Aufgabenseite neu, um sie zu verwerfen.";
                    })
            );
            hsButtonsDisabled = true;
        }
    }

};

export default module;